<template>
  <div class="relative">
    <div v-if="active" class="progress-line"></div>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
.progress-line {
  position: absolute;
  display: flex;
  display: -webkit-flex;
  background-color: transparent;
}
.progress-line, .progress-line:before {
  height: 2px;
  width: 100%;
  margin: 0;
}
.progress-line:before {
  background-color: #F9703E;
  content: '';
  -webkit-animation: running-progress 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  animation: running-progress 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
@-webkit-keyframes running-progress {
  0% { margin-left: 0px; margin-right: 100%; }
  50% { margin-left: 25%; margin-right: 0%; }
  100% { margin-left: 100%; margin-right: 0; }
}
@keyframes running-progress {
  0% { margin-left: 0px; margin-right: 100%; }
  50% { margin-left: 25%; margin-right: 0%; }
  100% { margin-left: 100%; margin-right: 0; }
}
</style>
